import React, { memo } from 'react';
import { IOption } from 'components/Select/Select';

import { TemplateFieldRow, RemoveIcon, InputRowContainer } from './styles';
import Input from 'components/Input';
import Button from 'components/Button';
import Collapsible from 'components/Collapsible';
import Select from 'components/Select';
import { IField } from 'store/tasks/tasksType';
import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
} from 'react-beautiful-dnd';
import i18n from '../../i18n';

interface IComponentProps {
  fields: IField[];
  onAddField: (e: React.MouseEvent) => void;
  onMoveItem: (sourceIndex: number, destIndex: number) => void;
  onRemoveField: (e: React.MouseEvent<HTMLSpanElement>) => void;
  onChangeField: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeFieldType: (key: number, value: IField['type']) => void;
  onChangeFieldAutoFillFunc: (
    key: number,
    value: IField['autoFillFunc']
  ) => void;
  onChangeFieldOptions: (key: number) => (options: IOption[]) => void;
  onChangeFieldConfigs: (key: number) => (options: IOption[]) => void;
}
const configs = ['checkInFindPreviousTask', 'showInTitle'];
const inputTypes = {
  text: { value: 'text', label: i18n.t('text', { ns: 'companyManagement' }) },
  html: { value: 'html', label: i18n.t('html', { ns: 'companyManagement' }) },
  multiSelect: {
    value: 'multiSelect',
    label: i18n.t('multiSelect', { ns: 'companyManagement' }),
  },
  date: { value: 'date', label: i18n.t('date', { ns: 'companyManagement' }) },
  // dateAndTime: { value: 'dateAndTime', label: 'تاریخ و ساعت' },
};
const autoFillTypes = {
  LastSibling_NotStarted: {
    value: 'LastSibling_NotStarted',
    label: i18n.t('LastSibling_NotStarted', { ns: 'companyManagement' }),
  },
  LastSibling_Started: {
    value: 'LastSibling_Started',
    label: i18n.t('LastSibling_Started', { ns: 'companyManagement' }),
  },
  LastSibling_Done: {
    value: 'LastSibling_Done',
    label: i18n.t('LastSibling_Done', { ns: 'companyManagement' }),
  },
  LastSibling_NextNumber: {
    value: 'LastSibling_NextNumber',
    label: i18n.t('LastSibling_NextNumber', { ns: 'companyManagement' }),
  },
  LastSibling_All: {
    value: 'LastSibling_All',
    label: i18n.t('LastSibling_All', { ns: 'companyManagement' }),
  },
  AllSibling_NotStarted: {
    value: 'AllSibling_NotStarted',
    label: i18n.t('AllSibling_NotStarted', { ns: 'companyManagement' }),
  },
  AllSibling_Started: {
    value: 'AllSibling_Started',
    label: i18n.t('AllSibling_Started', { ns: 'companyManagement' }),
  },
  ConvertVoiceToMeetingNote: {
    value: 'ConvertVoiceToMeetingNote',
    label: i18n.t('ConvertVoiceToMeetingNote', { ns: 'companyManagement' }),
  },
};

const TemplateFields: React.FC<IComponentProps> = ({
  fields,
  onAddField,
  onRemoveField,
  onChangeField,
  onChangeFieldType,
  onChangeFieldAutoFillFunc,
  onChangeFieldOptions,
  onMoveItem,
  onChangeFieldConfigs,
}) => (
  <Collapsible
    header={i18n.t('fieldsConfig', { ns: 'companyManagement' })}
    customBodyStyle={{ overflow: 'visible !important' }}
  >
    {/*@ts-expect-error JSX error*/}
    <DragDropContext
      onDragEnd={(result: DropResult) => {
        onMoveItem(result.source!.index, result.destination!.index);
      }}
    >
      <Droppable droppableId="droppable-1">
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            style={{ overflow: 'auto' }}
          >
            <>
              {fields.map((field, key) => {
                return (
                  <Draggable
                    key={field.name}
                    draggableId={field.name}
                    index={key}
                  >
                    {(provided) => {
                      return (
                        <div
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          ref={provided.innerRef}
                        >
                          <TemplateFieldRow
                            key={`field-${key}`}
                            style={{ display: 'flex', flexDirection: 'column' }}
                          >
                            <InputRowContainer>
                              <div>
                                <Input
                                  type="text"
                                  id={`field-${key}-title`}
                                  onChange={onChangeField}
                                  data-field-type="title"
                                  data-field-index={key}
                                  value={field.title}
                                  placeholder={
                                    i18n.t('title', {
                                      ns: 'companyManagement',
                                    }) as string
                                  }
                                  label={
                                    i18n.t('title', {
                                      ns: 'companyManagement',
                                    }) as string
                                  }
                                />
                              </div>
                              <Select
                                label={
                                  i18n.t('inputTypeLabel', {
                                    ns: 'companyManagement',
                                  }) as string
                                }
                                values={
                                  field.type
                                    ? [inputTypes[field.type]]
                                    : [inputTypes['text']]
                                }
                                options={Object.values(inputTypes)}
                                isRequired={true}
                                allowRemove={false}
                                onChangeValues={(types) => {
                                  const typeValue = types[0]
                                    ? types[0].value
                                    : inputTypes.text.value;
                                  onChangeFieldType(
                                    key,
                                    typeValue as IField['type']
                                  );
                                }}
                              />
                              {
                                <Select
                                  label={
                                    i18n.t('autoFillLabel', {
                                      ns: 'companyManagement',
                                    }) as string
                                  }
                                  values={
                                    field.autoFillFunc
                                      ? [autoFillTypes[field.autoFillFunc]]
                                      : []
                                  }
                                  options={Object.values(autoFillTypes)}
                                  isRequired={false}
                                  allowRemove={true}
                                  onChangeValues={(types) => {
                                    const autoFillFuncValue = types[0]
                                      ? types[0].value
                                      : undefined;
                                    onChangeFieldAutoFillFunc(
                                      key,
                                      autoFillFuncValue as IField['autoFillFunc']
                                    );
                                  }}
                                />
                              }
                              <div>
                                <Input
                                  type="text"
                                  id={`field-${key}-value`}
                                  onChange={onChangeField}
                                  data-field-type="value"
                                  data-field-index={key}
                                  value={field?.value || undefined}
                                  placeholder={i18n.t('defaultValue', {
                                    ns: 'companyManagement',
                                  })}
                                  label={
                                    i18n.t('defaultValue', {
                                      ns: 'companyManagement',
                                    }) as string
                                  }
                                />
                              </div>
                              <div>
                                <Select
                                  values={
                                    field.options
                                      ? Object.values(field.options).reduce(
                                          (list: IOption[], value) => {
                                            if (field.options) {
                                              const item: IOption = {
                                                value: field.options[
                                                  value
                                                ] as string,
                                                label: value,
                                              };
                                              list.push(item);
                                            }
                                            return list;
                                          },
                                          []
                                        )
                                      : []
                                  }
                                  options={[]}
                                  onChangeValues={onChangeFieldOptions(key)}
                                  letAddChip={true}
                                  multiChoice={true}
                                  placeholder={
                                    i18n.t('addingWithEnter', {
                                      ns: 'companyManagement',
                                    }) as string
                                  }
                                  label={
                                    i18n.t('options', {
                                      ns: 'companyManagement',
                                    }) as string
                                  }
                                />
                              </div>
                              <div>
                                <Select
                                  values={
                                    field.configs
                                      ? field.configs.reduce(
                                          (list: IOption[], value) => {
                                            if (field.configs) {
                                              const item: IOption = {
                                                value: value,
                                                label: i18n.t(value, {
                                                  ns: 'companyManagement',
                                                }) as string,
                                              };
                                              list.push(item);
                                            }
                                            return list;
                                          },
                                          []
                                        )
                                      : []
                                  }
                                  options={configs.map((it) => {
                                    return {
                                      value: it,
                                      label: i18n.t(it || '', {
                                        ns: 'companyManagement',
                                      }) as string,
                                    };
                                  })}
                                  onChangeValues={onChangeFieldConfigs(key)}
                                  letAddChip={true}
                                  multiChoice={true}
                                  placeholder={
                                    i18n.t('addingWithEnter', {
                                      ns: 'companyManagement',
                                    }) as string
                                  }
                                  label={
                                    i18n.t('configs', {
                                      ns: 'companyManagement',
                                    }) as string
                                  }
                                />
                              </div>
                            </InputRowContainer>
                            <InputRowContainer>
                              <div>
                                <Input
                                  type="checkbox"
                                  id={`field-${key}-required`}
                                  onChange={onChangeField}
                                  data-field-type="required"
                                  data-field-index={key}
                                  checked={field.required}
                                  label={
                                    i18n.t('required', {
                                      ns: 'companyManagement',
                                    }) as string
                                  }
                                />
                              </div>
                              <div>
                                <Input
                                  type="checkbox"
                                  id={`field-${key}-relatedToProgress`}
                                  onChange={onChangeField}
                                  data-field-type="relatedToProgress"
                                  data-field-index={key}
                                  checked={field.relatedToProgress}
                                  label={
                                    i18n.t('relatedToProgress', {
                                      ns: 'companyManagement',
                                    }) as string
                                  }
                                />
                              </div>
                              <div>
                                <Input
                                  type="checkbox"
                                  id={`field-${key}-highlight`}
                                  onChange={onChangeField}
                                  data-field-type="highlight"
                                  data-field-index={key}
                                  checked={field.highlight}
                                  label={
                                    i18n.t('highlight', {
                                      ns: 'companyManagement',
                                    }) as string
                                  }
                                />
                              </div>
                              <div>
                                <Input
                                  type="checkbox"
                                  id={`field-${key}-showInPrint`}
                                  onChange={onChangeField}
                                  data-field-type="showInPrint"
                                  data-field-index={key}
                                  checked={field.showInPrint}
                                  label={
                                    i18n.t('showInPrint', {
                                      ns: 'companyManagement',
                                    }) as string
                                  }
                                />
                              </div>
                            </InputRowContainer>
                            <RemoveIcon
                              onClick={onRemoveField}
                              data-field-name={field.name}
                              color="red"
                              type="x"
                            />
                          </TemplateFieldRow>
                        </div>
                      );
                    }}
                  </Draggable>
                );
              })}

              {provided.placeholder}
            </>
          </div>
        )}
      </Droppable>
    </DragDropContext>
    <div style={{ padding: '10px', marginTop: '100px' }}>
      <Button color="blue" onClick={onAddField}>
        {i18n.t('addField', { ns: 'companyManagement' }) as string}
      </Button>
    </div>
  </Collapsible>
);

export default memo(TemplateFields);
